export {};

export enum DistanceUnitBase {
    feet = "feet",
    yards = "yards",
    meters = "meters"
}

export enum DistanceUnitShort {
    feet = "ft",
    miles = "mi",
    yards = "yds",
    meters = "m",
    kilometers = "km"
}

export enum DistanceUnitLong {
    feet = "feet",
    miles = "miles",
    yards = "yards",
    meters = "meters",
    kilometers = "kilometers"
}

declare global {
    interface Number {
        metersToKilometers(): number
        metersToFeet(): number
        metersToYards(): number
        feetToMiles(): number
        feetToMeters(): number
        yardsToMeters(): number
        shouldShowLargerUnit(): boolean
        rounded(value: number): number
        beaconDistance(base: DistanceUnitBase): number
        beaconDistanceUnitLong(base: DistanceUnitBase): DistanceUnitLong
        beaconDistanceUnitShort(base: DistanceUnitBase): DistanceUnitShort
    }
}

Number.prototype.metersToKilometers = function(): number { return this.valueOf() / 1000; };
Number.prototype.metersToFeet = function(): number { return this.valueOf() * 3.28084; };
Number.prototype.metersToYards = function(): number { return this.valueOf() * 1.09361; };
Number.prototype.feetToMiles = function(): number { return this.valueOf() / 5280; };
Number.prototype.feetToMeters = function(): number { return this.valueOf() / 3.28084; };
Number.prototype.yardsToMeters = function(): number { return this.valueOf() / 1.09361; };

Number.prototype.rounded = function(value: number): number {
   return Math.round(this.valueOf() / value) * value;
};

Number.prototype.shouldShowLargerUnit = function(): boolean { return this.rounded(1) >= 1000; };

Number.prototype.beaconDistance = function(base: DistanceUnitBase): number {
    switch (base) {
        case DistanceUnitBase.feet: {
            const feet = this.metersToFeet();

            if (feet.shouldShowLargerUnit()) {
                return parseFloat(feet.feetToMiles().rounded(0.1).toFixed(1));
            } else {
                return feet.rounded(1);
            }
        }
        case DistanceUnitBase.yards: {
            return this.metersToYards().rounded(1);
        }
        case DistanceUnitBase.meters: {
            const meters = this.valueOf();

            if (meters.shouldShowLargerUnit()) {
                return parseFloat(meters.metersToKilometers().rounded(0.1).toFixed(1));
            } else {
                return meters.rounded(1);
            }
        }
    }
};

Number.prototype.beaconDistanceUnitShort = function(base: DistanceUnitBase): DistanceUnitShort {
    switch (base) {
        case DistanceUnitBase.feet: {
            const feet = this.metersToFeet();

            if (feet.shouldShowLargerUnit()) {
                return DistanceUnitShort.miles;
            } else {
                return DistanceUnitShort.feet;
            }
        }
        case DistanceUnitBase.yards: {
            return DistanceUnitShort.yards;
        }
        case DistanceUnitBase.meters: {
            const meters = this.valueOf();

            if (meters.shouldShowLargerUnit()) {
                return DistanceUnitShort.kilometers;
            } else {
                return DistanceUnitShort.meters;
            }
        }
    }
};

Number.prototype.beaconDistanceUnitLong = function(base: DistanceUnitBase): DistanceUnitLong {
    switch (base) {
        case DistanceUnitBase.feet: {
            const feet = this.metersToFeet();

            if (feet.shouldShowLargerUnit()) {
                return DistanceUnitLong.miles;
            } else {
                return DistanceUnitLong.feet;
            }
        }
        case DistanceUnitBase.yards: {
            return DistanceUnitLong.yards;
        }
        case DistanceUnitBase.meters: {
            const meters = this.valueOf();

            if (meters.shouldShowLargerUnit()) {
                return DistanceUnitLong.kilometers;
            } else {
                return DistanceUnitLong.meters;
            }
        }
    }
};